var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading && !_vm.initiallyLoaded
        ? _c("Loading", { attrs: { text: "Lade Verabschiedungen..." } })
        : [
            !_vm.isListTypeCustomer
              ? _c("JonInfo", {
                  staticClass: "mb-5",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "message",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\tHier werden Jobs/Arbeitgeber angezeigt, von denen du dich verabschiedet hast oder bei denen der\n\t\t\t\tArbeitgeber sich von dir verabschiedet hat.\n\t\t\t"
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2546501039
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "my-3" },
              [
                _c("b-form-radio-group", {
                  attrs: { options: _vm.filterTypeOptions },
                  on: { change: _vm.filterTypeChanged },
                  model: {
                    value: _vm.filterType,
                    callback: function($$v) {
                      _vm.filterType = $$v
                    },
                    expression: "filterType"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.sendoffs.length > 0
              ? _c(
                  "div",
                  {
                    class: ["items-list", { "loading-blockade": _vm.loading }]
                  },
                  [
                    _vm._l(_vm.sendoffs, function(item) {
                      return _c("ListItem", {
                        key: item.id,
                        attrs: { "list-item": item, "list-type": _vm.type },
                        on: { remove: _vm.loadSendoffs }
                      })
                    }),
                    _vm._v(" "),
                    _c("Pagination", {
                      staticClass: "mb-4",
                      attrs: {
                        page: _vm.page,
                        total: _vm.meta.total,
                        "items-per-page": _vm.itemsPerPage
                      },
                      on: { input: _vm.loadSendoffs },
                      model: {
                        value: _vm.page,
                        callback: function($$v) {
                          _vm.page = $$v
                        },
                        expression: "page"
                      }
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }